import { render, staticRenderFns } from "./TextInput2.vue?vue&type=template&id=3d52144e&scoped=true"
import script from "./TextInput2.vue?vue&type=script&lang=js"
export * from "./TextInput2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52144e",
  null
  
)

export default component.exports